export default {
  form: {
    title: "Login to Xplora",
    username: "Parents phone number",
    password: "Enter the code you received via SMS.",
    language: "Language",
    submit: "Login",
    continue: "Next",
    usernameValidationMessage: "Enter parent's phone number.",
    otpHint: "",
    phoneNumberInputInstructions:
      "Please enter your phone number without the country code (+46) or the leading zero.\nExample: 701234567\nDo not enter: 0701234567, 46701234567, or 460701234567",
  },
  logoutDialog: {
    title: "Logged in as",
  },
  loginInfo: {
    title: "Are you an Xplora subscriber?",
    content: `NOTE: If the subscription is for an Xplora watch, enter the parents' mobile number, not the smartwatch's. \n \n Please note that it may take up to 30 minutes from ordering until you can log in.`,
  },
} as const;
